import React, { useCallback } from 'react';
import Button from 'jd-library/Button';
import AnimateOnHover from 'jd-library/AnimateOnHover';
import style from './video-listing.scss';
import VideoPlayerWrapper from '../../common/Video/VideoPlayerWrapper';
import SliderWrapper from 'jd-library/SliderWrapper';
import historyHandler from 'jd-library/historyHandler';

const VideoPlayerSlider = props => {
    const onVideoClick = useCallback(() => {
        props.onClick && props.onClick()
    }, [props.onClick])

    return (
        <SliderWrapper
            slider={{
                className: style['video-player-holder']
            }}
            onHidden={props.onHidden}
        >
            {!props.isMobile && <AnimateOnHover className={style['back-icon-holder'] + " " + style['header-icon-holder']} onClick={historyHandler.closeCurrent}>
                <i className={'icon-HDRback'}></i>
            </AnimateOnHover>}
            <AnimateOnHover className={style['close-icon-holder'] + " " + style['header-icon-holder']} onClick={historyHandler.closeCurrent}>
                <i className={'icon-HDRcross'}></i>
            </AnimateOnHover>
            <div className={style['react-player-holder']}>
                <VideoPlayerWrapper 
                    {...props}
                    onClick={onVideoClick}
                />
            </div>
            <div className={style['footer-btn-holder']}>
                <Button
                    className={style['footer-btn']}
                    clickHandler={() => props.onVideoSelect()}
                    size='lg'
                >
                    Select Video
                </Button>
            </div>
        </SliderWrapper>
    )
}

export default VideoPlayerSlider;